<template>
  <div class="left_content">
    <div class="left_title">人车管控</div>
    <div class="left_perver">
      <div class="left_perver_left">
        <div class="right_person_sigle">
          <div>
            <dv-digital-flop :config="personsMember1" style="width: 38px; height: 38px" />
          </div>
          <p>厂区员工</p>
        </div>
        <div class="right_person_sigle">
          <div>
            <dv-digital-flop :config="personsMember2" style="width: 38px; height: 38px" />
          </div>
          <p>外来人员</p>
        </div>
<!--        <div class="left_title" style="margin-top: 0;">隐患管理</div>
        <div class="right_ftoday">
          <div class="right_ftoday_side">
            <dv-digital-flop :config="monitorEnter" style="width: 118px; height: 30px" />
            <p>排查计划</p>
          </div>
          <div class="right_ftoday_mid">
            <dv-digital-flop :config="monitorAll" style="width: 103px; height: 30px" />
            <p>隐患数量</p>
          </div>
          <div class="right_ftoday_side">
            <dv-digital-flop :config="monitorOut" style="width: 118px; height: 30px" />
            <p>排查任务</p>
          </div>
        </div>-->
        <div class="right_person_sigle">
          <div>
            <dv-digital-flop :config="personsMember4" style="width: 38px; height: 38px" />
          </div>
          <p>在线人数</p>
        </div>
      </div>
      <div class="left_perver_right">
        <div class="left_perver_right_btn" @click="searchIfShow()">人车追踪</div>
      </div>
    </div>
    <div class="left_title">风险分区</div>
    <div class="left_area">
      <div class="left_area_side">
        <dv-digital-flop :config="dengerousArea" style="width: 100px; height: 30px" />
        <div>风险区域</div>
      </div>
      <div class="left_area_mid">
        <dv-charts :option="optionArea" />
      </div>
      <div class="left_area_side">
        <dv-digital-flop :config="dengerousPoint" style="width: 100px; height: 30px" />
        <div>风险点</div>
      </div>
    </div>
    <div class="left_title" style="margin-top: 0;">隐患管理</div>
    <div class="right_ftoday">
      <div class="right_ftoday_side">
        <dv-digital-flop :config="monitorEnter" style="width: 118px; height: 30px" />
        <p>排查计划</p>
      </div>
      <div class="right_ftoday_mid">
        <dv-digital-flop :config="monitorAll" style="width: 103px; height: 30px" />
        <p>隐患数量</p>
      </div>
      <div class="right_ftoday_side">
        <dv-digital-flop :config="monitorOut" style="width: 118px; height: 30px" />
        <p>排查任务</p>
      </div>
    </div>
    <div class="left_danger">
      <div class="left_dangerl">
        <dv-charts :option="optionHiddenDenger" />
      </div>
      <div class="left_dangerr">
        <dv-charts :option="optionPolice" />
      </div>
    </div>
    <div class="left_title" style="margin-top: 0;">作业票</div>
    <div class="left_workticket">
      <ul>
        <li v-for="(item, index) in workticket" :key="index">
          <img src="./img/icon1.png" />
          <p>{{ item.number }}</p>
          <div>{{ item.title }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getFxListNew, getRiskPointList, getTroubleshootTask, getWorkPermitList, getWorkerList, getAllWorker, getTroubleshootPlan, countMonth } from "@/api/api"

import CONSTANTS from "./map/constants";
import { mapMutations, mapGetters } from "vuex"
// left
export default {
  name: "LeftMain",
  components: {},
  computed: {
    ...mapGetters([
      'onlineUserCount',
      'riskAreaList'
    ])
  },
  data() {
    return {
      personsMember1: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 12,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      personsMember2: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 12,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      personsMember3: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 12,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      personsMember4: {
        number: [11],
        content: "{nt}",
        style: {
          fontSize: 12,
          fill: '#fff',
          fontWeight: 'bold'
        }
      },
      dengerousArea: {
        number: [13],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: "#fff",
          fontWeight: "bold",
        },
      },
      dengerousPoint: {
        number: [13],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: "#fff",
          fontWeight: "bold",
        },
      },
      // 风险分区
      optionArea: {
        title: {
          text: "风险分区",
          show: false,
        },
        series: [
          {
            type: "pie",
            data: [],
            insideLabel: {
              show: true,
            },
            radius: "45%",
            outsideLabel: {
              labelLineEndLength: 0,
              labelLineBendGap: "10%",
            },
            radius: ["40%", "50%"],
            insideLabel: {
              show: false,
              formatter: "{b}: {c}({d}%)",
            },
          },
        ],
        grid: {
          style: {
            fill: "rgba(0, 0, 0, 0)",
          },
          top: "30px",
          left: "10px",
          right: "10px",
          bottom: "20px",
        },
      },
      // 隐患趋势
      optionHiddenDenger: {
        title: {
          text: "隐患趋势",
          show: true,
          style: {
            fill: "#fff",
            fontSize: 12,
            textAlign: "center",
            textBaseline: "bottom",
            fontWeight: "normal",
          },
        },
        series: [
          {
            type: "pie",
            data: [
              { name: "示例一", value: 1 },
              { name: "示例二", value: 1 },
              { name: "示例三", value: 1 },
              { name: "示例四", value: 1 },
              { name: "示例五", value: 1 },
              { name: "示例六", value: 1 },
            ],
            insideLabel: {
              show: true,
            },
            radius: "45%",
            outsideLabel: {
              labelLineEndLength: 4,
              labelLineBendGap: "5%",
            },
          },
        ],
        grid: {
          style: {
            fill: "rgba(0, 0, 0, 0)",
          },
          top: "30px",
          left: "10px",
          right: "10px",
          bottom: "20px",
        },
      },
      // 报警趋势
      optionPolice: {
        title: {
          text: "报警趋势",
          show: true,
          style: {
            fill: "#fff",
            fontSize: 12,
            textAlign: "center",
            textBaseline: "bottom",
            fontWeight: "normal",
          },
        },
        xAxis: {
          data: ["示例一", "", "示例三", "", "示例五", ""],
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
            interval: 1,
          },
          axisLine: {
            show: true, // 设置x轴线显示
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          axisTick: {
            show: true,
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
            // 排查任务
            monitorEnter: {
              number: [23],
              content: "{nt}",
              style: {
                fontSize: 22,
                fill: "#c97c0e",
                fontWeight: "bold",
              },
            },
            // 排查记录
            monitorOut: {
              number: [23],
              content: "{nt}",
              style: {
                fontSize: 22,
                fill: "#c97c0e",
                fontWeight: "bold",
              },
            },
          },
          axisTick: {
            show: true,
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          splitLine: {
            // y轴中间线是否显示
            show: false,
          },
        },
        series: [
          {
            data: [20, 70, 40, 60, 18, 80],
            type: "line",
            // smooth: true,
          },
        ],
        color: ["#1890FF"], // 折线颜色
        grid: {
          style: {
            fill: "rgba(0, 0, 0, 0)",
          },
          top: "30px",
          left: "10px",
          right: "10px",
          bottom: "20px",
        },
        linePoint: {
          show: false,
        },
      },
      // 重大危险源
      monitorAll: {
        number: [13],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: "#c97c0e",
          fontWeight: "bold",
        },
      },
      // 排查任务
      monitorEnter: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: "#c97c0e",
          fontWeight: "bold",
        },
      },
      // 排查记录
      monitorOut: {
        number: [23],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: "#c97c0e",
          fontWeight: "bold",
        },
      },
      workticket: [
        {
          icon: "@/img/icon2.png",
          number: 0,
          title: "临时用电作业",
        },
        {
          icon: "./img/icon1.png",
          number: 0,
          title: "动火作业",
        },
        {
          icon: "./img/icon1.png",
          number: 0,
          title: "受限空间作业",
        },
        {
          icon: "./img/icon1.png",
          number: 0,
          title: "盲板抽堵作业",
        },
        {
          icon: "./img/icon1.png",
          number: 0,
          title: "高处安全作业",
        },
        {
          icon: "./img/icon1.png",
          number: 0,
          title: "吊装安全作业",
        },
        {
          icon: "./img/icon1.png",
          number: 0,
          title: "断路安全作业",
        },
        {
          icon: "./img/icon1.png",
          number: 0,
          title: "动土安全作业",
        },
      ],
      // 搜索
      search: {
        entity: null,
        time: null,
        play: null
      },
      searchShow: false,
    };
  },
  watch: {
    onlineUserCount: function () {
      this.personsMember4.number[0] = this.onlineUserCount;//TODO: 在线人数
      this.personsMember4 = { ...this.personsMember4 };

    },
    riskAreaList: function () {
      //获取风险区域
      this.dengerousArea.number[0] = this.riskAreaList.length;
      this.dengerousArea = { ...this.dengerousArea };
      this.optionArea.series[0].data = [];
      ["低风险", "一般风险", "较大风险", "重大风险"].forEach(item => {
        this.optionArea.series[0].data.push({ name: item, value: this.riskAreaList.filter(i => i.color == item).length });
      })
      this.optionArea = { ...this.optionArea };
    }
  },
  mounted() {
    this.updateHandler();
    //临时用电
    this.getWorkPermit("3", 0);
    //动火作业
    this.getWorkPermit("4", 1);
    //受限空间
    this.getWorkPermit("7", 2);
    //盲板抽堵安全
    this.getWorkPermit("8", 3);
    //高处安全
    this.getWorkPermit("9", 4);
    //吊装安全
    this.getWorkPermit("10", 5);
    //断路安全
    this.getWorkPermit("11", 6);
    //动土安全
    this.getWorkPermit("12", 7);
  },
  methods: {
    updateHandler() {
      let self = this;
      /**
       * 只是这样做是无效
       * config指向的内存地址没有发生变化
       * 组件无法侦知数据变化
       */
      this.monitorAll.number[0] = 0;

      this.monitorOut.number[0] = 0;
      this.dengerousArea.number[0] = 0;

      this.personsMember1.number[0] = 0;
      getWorkerList().then(result => {
        if (result.data.status_code == 100) {
          self.personsMember1.number[0] = result.data.data.length;
          self.personsMember1 = { ...self.personsMember1 };
        }
      })
      this.personsMember2.number[0] = 0;
      this.personsMember3.number[0] = 0;
      this.personsMember4.number[0] = this.onlineUserCount;//TODO: 在线人数
      console.log(this.onlineUserCount)
      //获取风险点
      getRiskPointList({ limit: 10000, curPage: 1 }).then(res => {
        if (res.data.status_code === 100) {
          self.dengerousPoint.number[0] = res.data.cum;
          self.dengerousPoint = { ...self.dengerousPoint };
        }
      })

      //获取获取排查任务
      countMonth().then(res => {
        if (res.data.status_code === 100) {
          self.monitorOut.number[0] = res.data.data.troubleshootTaskCount;
          self.monitorOut = { ...self.monitorOut };
        }
      });


      //获取获取巡检计划
      getTroubleshootPlan({ limit: 10000, curPage: 1, endTime: '', name: '', planEndTime: '', planStartTime: '', startTime: '', status: '' }).then(res => {
        console.log(res);
        if (res.data.status_code === 100) {
          self.monitorEnter.number[0] = res.data.cum;
          self.monitorEnter = { ...self.monitorEnter };
        }
      })
      /**
       * 使用ES6拓展运算符生成新的props对象
       * 组件侦知数据变化 自动刷新状态
       */
      this.monitorAll = { ...this.monitorAll };
      this.personsMember1 = { ...this.personsMember1 };
      this.personsMember2 = { ...this.personsMember2 };
      this.personsMember3 = { ...this.personsMember3 };
      this.personsMember4 = { ...this.personsMember4 };
    },

    /**
     * //获取作业票
     * @param type 类型
     * @param index 索引
     */
    getWorkPermit(type, index) {
      getWorkPermitList({ limit: 10000, curPage: 1, certificateTypeId: type }).then(res => {
        if (res.data.status_code === 100) {
          this.workticket[index].number = res.data.cum;
        }
      })
    },
    /*
        搜索框的显示和隐藏
     */
    searchIfShow(status) {
      this.EventCenter.emit(CONSTANTS.EVENTS.TRACKPLAY, {});
    }
  },
};
</script>

<style lang="less">
ul,
li,
p {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.left_content {
  position: absolute;
  width: 390px;
  height: 897px;
  // background: url(./img/bg_right.png) no-repeat;
  //background: linear-gradient(to right, rgb(6, 28, 50, 0.1), rgba(6, 28, 50, 0.1));
  background: linear-gradient(to left, rgba(0, 0, 0, .1), rgba(0, 0, 0, .1));
  position: absolute;
  left: 0px;
  top: 75px;
  z-index: 990;

  .left_title {
    height: 35px;
    line-height: 35px;
    overflow: hidden;
    width: 400px;
    font-family: sans-serif;
    display: flex;
    margin: 5px auto 0;
    background: url(./img/bg_rightline.png) 110px center no-repeat;
    background-size: 61%;
    font-size: 18px;
    letter-spacing: 2px;
    color: #fff;
    font-weight: bold;
    margin-left: 25px;
  }

  .left_workticket {
    height: auto;
    overflow: hidden;
    clear: both;
    width: 400px;
    margin: 0px auto 0;

    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 80px;
        text-align: center;
        margin: 10px 10px 0 10px;
        flex-shrink: 0;

        img {
          width: 30px;
          height: 30px;
        }

        p {
          color: #c97c0e;
          font-weight: bold;
          height: 20px;
          line-height: 20px;
        }

        div {
          color: #b3c4c9;
          font-size: 13px;
          height: 20px;
          line-height: 20px;
        }
      }
    }
  }

  .right_ftoday {
    width: 346px;
    height: 72px;
    margin: 8px auto 0;
    border: 1px solid #c97c0e;
    border-radius: 10px;
    display: flex;

    p {
      margin: 0;
      padding: 0;
    }

    .right_ftoday_side {
      width: 118px;
      text-align: center;
      margin-left: 5px;

      div {
        font-size: 16px;
        height: 33px;
        line-height: 33px;
        color: #c97c0e;
        font-weight: bold;
        margin-top: 16px;
      }

      p {
        font-size: 16px;
        height: 32px;
        line-height: 26px;
        color: #b3c4c9;
        letter-spacing: 2px;
      }
    }

    .right_ftoday_mid {
      background: url(./img/bg_ftoday.png) no-repeat;
      background-size: 80px;
      width: 80px;
      height: 73px;
      margin-left: 15px;
      text-align: center;

      div {
        font-size: 22px;
        height: 33px;
        margin-left: -12px;
        line-height: 33px;
        color: #c97c0e;
        font-weight: bold;
        margin-top: 22px;
      }

      p {
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #b3c4c9;
        letter-spacing: 2px;
      }
    }
  }

  .left_danger {
    width: 400px;
    height: 160px;
    margin: 20px auto 0;
    display: flex;

    .left_dangerl {
      height: 150px;
      width: 290px;
    }

    .left_dangerr {
      height: 150px;
      width: 290px;
    }
  }

  .left_area {
    width: 400px;
    margin: 0px auto;
    display: flex;

    .left_area_mid {
      width: 200px;
      height: 122px;
    }

    .left_area_side {
      width: 100px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      div {
        font-size: 12px;
        color: #b3c4c9;
        margin-top: 10px;
      }
    }
  }

  .left_perver {
    width: 400px;
    height: auto;
    overflow: hidden;
    margin: 0px auto;
    display: flex;

    .left_perver_left {
      position: relative;
      height: 130px;
      width: 224px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .right_person_sigle {
        width: 90px;
        margin: 0 3px;
        flex-shrink: 0;

        .dv-digital-flop {
          font-size: 12px;
          color: #fff;
          letter-spacing: 2px;
          background-image: url(./img/bg_memsigle.png);
          background-size: 100%;
          text-align: center;
          width: 38px;
          height: 38px;
          margin: 3px auto 0;
          overflow: hidden;
          line-height: 38px;
          font-weight: bold;
        }

        p {
          font-size: 12px;
          color: #b3c4c9;
          letter-spacing: 2px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          margin: 0;
        }
      }
    }

    .left_perver_left::before {
      position: absolute;
      left: 0;
      top: 25px;
      bottom: 10px;
      // height: 150px;
      width: 1px;
      background: #b3c4c9;
      content: "";
    }

    .left_perver_left::after {
      position: absolute;
      right: 0;
      top: 25px;
      bottom: 10px;
      // height: 150px;
      width: 1px;
      background: #b3c4c9;
      content: "";
    }
  }

  .left_perver_right {
    margin-left: 30px;

    .left_perver_right_btn {
      width: 120px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #b3c4c9;
    }
  }
}
</style>
